import React, { useState, useEffect, useContext } from "react";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import { createTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import Slider from "@material-ui/core/Slider";
import Select from "react-select";
import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import axios from "axios";
import {
  MuiPickersUtilsProvider,
  DatePicker,
  DateTimePicker,
} from "@material-ui/pickers";
import { StoreContext } from "../../../Store/Provider";
import { HOST_URL } from "../../../Config";
import moment from "moment";
import "./schedule.css";
import { useNavigate } from "react-router";
import { getUserData, localStoragekey } from "../../Common/Utility/Utils";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { NotificationManager } from "react-notifications";
import { routeConstant } from "../../../Route/utils/routeConstant";
// import { DateTimePicker } from "@material-ui/pickers";

const AirbnbSlider = withStyles({
  root: {
    color: "rgba(var(--text-heading-light))",
    height: 3,
    padding: "13px 0",
  },
  thumb: {
    height: 20,
    width: 20,
    backgroundColor: "rgba(var(--text-heading-light))",
    border: "1px solid rgba(var(--text-heading-light))",
    marginTop: -9,
    marginLeft: -13,
    boxShadow: "#ebebeb 0 2px 2px",
    "&:focus, &:hover, &$active": {
      boxShadow: "#ccc 0 2px 3px 1px",
    },
    "& .bar": {
      // display: inline-block !important;
      height: 9,
      width: 1,
      backgroundColor: "currentColor",
      marginLeft: 1,
      marginRight: 1,
    },
  },
  active: {},
  track: {
    height: 3,
  },
  rail: {
    color: "rgba(0, 185, 181,0.1)",
    opacity: 1,
    height: 3,
  },
})(Slider);

function AirbnbThumbComponent(props) {
  return <span {...props}></span>;
}

const materialTheme = createTheme({
  palette: {
    primary: {
      main: "rgba(var(--text-heading-light))",
    },
  },
});

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function ScheduleForm(props) {
  const [value, setValue] = useState("A");
  const history = useNavigate();
  const [open, setOpen] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [valuetoset, setValuetoset] = useState("Latest Arrival Date");
  const [valueSlider, setValueSlider] = useState(2);
  const [countryObject, setCountryObject] = useState([]);
  const [originportObject, setOriginPortObject] = useState([]);
  const [destportObject, setDestPortObject] = useState([]);
  const [originCountry, setOriginCountry] = useState("");
  const [originPort, setOriginPort] = useState("");
  const [destinationCountry, setDestinationCountry] = useState("");
  const [destinationPort, setDestinationPort] = useState("");
  const [sealineslist, setSealineslist] = useState([]);
  const [sealines, setSealines] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [transportmode, setTransportmode] = useState("SEA");
  const [apiLoading, setApiLoading] = useState({
    country: false,
    originPort: false,
    destinationPort: false,
    sealine: false,
  });
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  const context = useContext(StoreContext);
  useEffect(() => {
    getCountry();
    getSealines();
  }, []);

  const handleChange = (event) => {
    if (transportmode === "SEA") {
      setValue(event.target.value);
    }
  };

  const handleSliderChange = (event, newValue) => {
    setValueSlider(newValue);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const getCountry = () => {
    setApiLoading({ ...apiLoading, country: true });
    const URL = `${HOST_URL}api/GetAllCountries`;
    axios
      .get(URL)
      .then((res) => {
        setCountryObject(res.data.countries);
        setApiLoading({ ...apiLoading, country: false });
      })
      .catch((err) => {
        console.log(err);
        setApiLoading({ ...apiLoading, country: false });
      });
  };

  const getPortOrigin = (props, isSea) => {
    // console.log("props", isSea);
    setOriginPortObject([]);
    setApiLoading({ ...apiLoading, originPort: true });
    if (props) {
      const URL = `${HOST_URL}api/GetPorts?country_code=${props.value}&IsSEA=${isSea}`;
      axios
        .get(URL)
        .then((res) => {
          setOriginPortObject(res.data.ports);
          setApiLoading({ ...apiLoading, originPort: false });
        })
        .catch((err) => {
          console.log(err);
          setApiLoading({ ...apiLoading, originPort: false });
        });
    }
  };

  const getPortDest = (props, isSea) => {
    setDestPortObject([]);
    setApiLoading({ ...apiLoading, destinationPort: true });
    if (props) {
      const URL = `${HOST_URL}api/GetPorts?country_code=${props.value}&IsSEA=${isSea}`;
      axios
        .get(URL)
        .then((res) => {
          setDestPortObject(res.data.ports);
          setApiLoading({ ...apiLoading, destinationPort: false });
        })
        .catch((err) => {
          console.log(err);
          setApiLoading({ ...apiLoading, destinationPort: false });
        });
    }
  };

  const getSealines = (isSea) => {
    setApiLoading({ ...apiLoading, sealine: true });
    const URL = `${HOST_URL}api/GetAllSeaLines?IsSEA=${isSea}`;
    axios
      .get(URL)
      .then((res) => {
        setSealineslist(res?.data?.lines ?? []);
        setApiLoading({ ...apiLoading, sealine: false });
      })
      .catch((err) => {
        console.log(err);
        setSealineslist([]);

        setApiLoading({ ...apiLoading, sealine: false });
      });
  };

  const countryObjectOption = countryObject.map((countrylist) => {
    return {
      value: countrylist.key,
      label: `${countrylist.name} (${countrylist.key})`,
      fullName: countrylist.name,
    };
  });

  const originportObjectOption = originportObject.map((originportlist) => {
    return {
      value: originportlist.key,
      label: `${originportlist.name} (${originportlist.key})`,
      fullName: originportlist.name,
    };
  });

  const destinationportObjectOption = destportObject.map(
    (destinationportlist) => {
      return {
        value: destinationportlist.key,
        label: `${destinationportlist.name} (${destinationportlist.key})`,
        fullName: destinationportlist.name,
      };
    }
  );

  const seaLinesObject = sealineslist.map((sealineslist) => {
    return {
      value: sealineslist.key,
      label: `${sealineslist.name} (${sealineslist.key})`,
    };
  });
  const newAllOption = {
    value: "",
    label: "ALL",
  };
  const seaLinesObjectOption = [newAllOption].concat(seaLinesObject);

  const resetSchedule = () => {
    setValue("A");
    setValueSlider(2);
    setOriginPortObject([]);
    setDestPortObject([]);
    setOriginCountry("");
    setOriginPort("");
    setDestinationCountry("");
    setDestinationPort("");
    setSealines("");
    setSelectedDate(null);
    setTransportmode("SEA");
  };

  const getSearchResult = async () => {
    if (originCountry === "") {
      NotificationManager.error("Please select Origin Country.", "", 3000);
    } else if (originPort.value === undefined) {
      NotificationManager.error("Please select Origin Port.", "", 3000);
    } else if (destinationCountry === "") {
      NotificationManager.error("Please select Destination Country.", "", 3000);
    } else if (destinationPort.value === undefined) {
      NotificationManager.error("Please select Destination Port.", "", 3000);
    } else if (originPort.value === destinationPort.value) {
      NotificationManager.error(
        "Please select different Destination.",
        "",
        3000
      );
    } else if (selectedDate === null) {
      NotificationManager.error("Please select Date.", "", 3000);
    } else if (valueSlider === 0) {
      NotificationManager.error("Please select weeks.", "", 3000);
    } else {
      setLoading(true);
      const startDate = moment(selectedDate).format("DD-MM-YYYY");

      if (value === "A") {
        setValuetoset("Latest Arrival Date");
      } else if (value === "D") {
        setValuetoset("Earlier Departure Date");
      }
      context.setRequestQuote({
        origincountry: originCountry.label,
        OriginPort: originPort.value,
        OriginPortFullName: originPort.fullName,
        destinationCountry: destinationCountry.label,
        destinationPort: destinationPort.value,
        destinationPortFullName: destinationPort.fullName,
        availvableDirection: valuetoset,
        availvableDirectionShort: value,
        dateShip: startDate,
        weekAhead: valueSlider,
        sealines: sealines.label ?? "",
        selectedDate: selectedDate,
        transportmode: transportmode,
      });
      let userData = {};
      await getUserData(localStoragekey)
        .then((res) => {
          userData = res;
        })
        .catch((err) => {
          userData = {};
        });
      const header = {
        Authorization: `Bearer ${userData.access_token}`,
        username: `${userData.userName}`,
        grant_type: "password",
        password: `${userData.userSecret}`,
      };
      const URL = `${HOST_URL}api/GetSearchResults?origin_code=${
        originPort.value
      }&destination_code=${
        destinationPort.value
      }&start_date=${startDate}&weeks_ahead=${valueSlider}&direction_A_or_D=${value}&sac_codes=${
        sealines.value ?? ""
      }&searchtype=${transportmode}`;
      axios
        .post(URL, {
          headers: header,
        })
        .then((res) => {
          if (res.data.shipping_lines) {
            context.setSearchResult(res.data.shipping_lines);
          }

          setLoading(false);
          history(routeConstant.ScheduleSearchResult);
        })
        .catch((err) => {
          console.log(err);
          if (err.response) {
            NotificationManager.error(err.response.data.Message, "", 3000);
          } else if (err.request) {
            NotificationManager.error("Something went wrong!", "", 3000);
          } else if (err.message) {
            NotificationManager.error("Something went wrong!", "", 3000);
          } else {
            NotificationManager.error("Something went wrong!", "", 3000);
          }
          setLoading(false);
        });
    }
  };

  const handleTransportMode = (e) => {
    if (e) {
      setValue("D");
      setValueSlider(2);
      setOriginPortObject([]);
      setDestPortObject([]);
      setOriginCountry("");
      setOriginPort("");
      setDestinationCountry("");
      setDestinationPort("");
      setSealines("");
      setSelectedDate(null);
      setTransportmode("SEA");
      context.setTransportmodeglobal("SEA");
    }
  };

  const checkedair = () => {
    if (transportmode === "AIR") {
      return true;
    }
    return false;
  };

  const checkedsea = () => {
    if (transportmode === "SEA") {
      return true;
    }
    return false;
  };

  return (
    <>
      <div className="row my-3">
        <div className="divTransportmode">
          <p>Select Transport Mode</p>
          <div>
            <span>
              <input
                type="radio"
                value={transportmode}
                checked={checkedair()}
                onChange={() => {
                  setValue("A");
                  setValueSlider(2);
                  setOriginPortObject([]);
                  setDestPortObject([]);
                  setOriginCountry("");
                  setOriginPort("");
                  setDestinationCountry("");
                  setDestinationPort("");
                  setSealines("");
                  setSelectedDate(null);
                  setTransportmode("AIR");
                  context.setTransportmodeglobal("AIR");
                  handleTransportMode();
                  getSealines(false);
                }}
              />{" "}
              Air
            </span>
            <span>
              <input
                type="radio"
                value={transportmode}
                checked={checkedsea()}
                defaultChecked
                onChange={() => {
                  setValue("A");
                  setValueSlider(2);
                  setOriginPortObject([]);
                  setDestPortObject([]);
                  setOriginCountry("");
                  setOriginPort("");
                  setDestinationCountry("");
                  setDestinationPort("");
                  setSealines("");
                  setSelectedDate(null);
                  setTransportmode("SEA");
                  context.setTransportmodeglobal("SEA");
                  handleTransportMode();
                  getSealines(true);
                }}
              />{" "}
              Sea
            </span>
          </div>
        </div>
        <div className="col-md-6 col-12 px-xl-5 px-lg-4 px-md-3 px-sm-2 px-xs-1 scheduleCompSelect">
          <div className="scheduleCompSelectInner">
            <label className="form-label">Origin*</label>
            <Select
              className="reactSelect"
              isLoading={apiLoading.country}
              placeholder="Select Country"
              options={countryObjectOption}
              value={originCountry}
              onChange={(selectedOption) => {
                setOriginCountry(selectedOption);
                setOriginPort("");
              }}
            />
            <div
              className="reactSelectParent"
              onClick={() => {
                transportmode === "SEA"
                  ? getPortOrigin(originCountry, true)
                  : getPortOrigin(originCountry, false);
              }}
            >
              <Select
                className="reactSelect"
                isLoading={originCountry.value ? apiLoading.originPort : null}
                placeholder="Select Port"
                options={originportObjectOption}
                value={originPort}
                onChange={(selectedOption) => setOriginPort(selectedOption)}
              />
            </div>
          </div>
          <div className="scheduleCompSelectInner">
            <label className="form-label">
              {transportmode === "SEA" ? "Sealine" : "Airline"}
            </label>
            <Select
              className="reactSelect"
              isLoading={apiLoading.sealine}
              placeholder="All"
              options={seaLinesObjectOption}
              value={sealines}
              onChange={(selectedOption) => setSealines(selectedOption)}
            />
          </div>

          <div className="scheduleCompSelectInner">
            <label className="form-label">Weeks Ahead</label>
            <AirbnbSlider
              onChange={handleSliderChange}
              value={valueSlider}
              ThumbComponent={AirbnbThumbComponent}
              defaultValue={[2]}
              max={transportmode === "AIR" ? 3 : 10}
            />
            {valueSlider > 0 ? (
              <div className="weekShow">{valueSlider} weeks</div>
            ) : null}
          </div>
        </div>
        <div className="col-md-6 col-12 px-xl-5 px-lg-4 px-md-3 px-sm-2 px-xs-1 scheduleCompSelect">
          <div className="scheduleCompSelectInner">
            <label className="form-label">Destination*</label>
            <Select
              className="reactSelect"
              isLoading={apiLoading.country}
              placeholder="Select Country"
              options={countryObjectOption}
              value={destinationCountry}
              onChange={(selectedOption) => {
                setDestinationCountry(selectedOption);
                setDestinationPort("");
              }}
            />
            <div
              className="reactSelectParent"
              onClick={() => {
                transportmode === "SEA"
                  ? getPortDest(destinationCountry, true)
                  : getPortDest(destinationCountry, false);
              }}
            >
              <Select
                className="reactSelect"
                isLoading={
                  destinationCountry.value ? apiLoading.destinationPort : null
                }
                placeholder="Select Port"
                options={destinationportObjectOption}
                value={destinationPort}
                onChange={(selectedOption) =>
                  setDestinationPort(selectedOption)
                }
              />
            </div>
          </div>
          <div className="scheduleCompSelectInner dateShipmentSelection">
            <label className="form-label">Date to Ship*</label>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <ThemeProvider theme={materialTheme}>
                <DatePicker
                  minDate={new Date()}
                  clearable
                  id="shipDate"
                  placeholder="dd-mm-yyyy"
                  format="dd-MM-yyyy"
                  value={selectedDate}
                  onChange={(date) => handleDateChange(date)}
                />
              </ThemeProvider>
            </MuiPickersUtilsProvider>
          </div>
          {transportmode !== "AIR" ? (
            <div className="scheduleCompSelectInner mb-0">
              <label className="form-label">Available Direction</label>
              <RadioGroup
                className="selectDirection"
                name="availableDirection"
                value={value}
                onChange={handleChange}
              >
                <FormControlLabel
                  value="D"
                  control={<Radio color="primary" />}
                  label="Earlier Departure Date"
                />
                <FormControlLabel
                  value="A"
                  control={<Radio color="primary" />}
                  label="Latest Arrival Date"
                />
              </RadioGroup>
            </div>
          ) : null}
        </div>
      </div>
      <div className="shipmentheaderbuttongroups">
        <Button
          variant="contained"
          className="shipmentheaderbutton"
          onClick={resetSchedule}
        >
          Reset
        </Button>
        <Button
          variant="contained"
          className="shipmentheaderbutton selected"
          onClick={getSearchResult}
        >
          &nbsp;
          {loading ? (
            <CircularProgress size="1rem" color="inherit" />
          ) : (
            "Search"
          )}
          &nbsp;
        </Button>
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          open={open}
          autoHideDuration={3000}
          onClose={handleClose}
        >
          <Alert severity={"error"} onClose={handleClose}>
            {alertText}
          </Alert>
        </Snackbar>
      </div>
    </>
  );
}

export default ScheduleForm;
